import type { GameState } from "@dailywars/core/engine";

import type { CanvasBoardAnimation } from "#/game/animation/types";

import { drawAttackRangeFlashLayer } from "./attackRangeFlash";
import { drawCaptureBarsLayer } from "./boardCaptureBars";
import type { CanvasViewState } from "./boardConstants";
import { drawFxOverUnitsLayer, drawFxUnderUnitsLayer } from "./boardFxEffects";
import { drawRoadStripesLayer, drawTerrainLayer } from "./boardMapLayers";
import { drawTileOverlaysLayer } from "./boardTileOverlays";
import { drawUnitsLayer } from "./boardUnitsDraw";

export function drawTerrainAndRoads(ctx: CanvasRenderingContext2D, state: GameState): void {
  drawTerrainLayer(ctx, state);
  drawRoadStripesLayer(ctx, state);
}

export function drawDynamicLayers({
  ctx,
  state,
  viewState,
  animation,
  nowMs,
}: {
  ctx: CanvasRenderingContext2D;
  state: GameState;
  viewState: CanvasViewState;
  animation: CanvasBoardAnimation | null;
  nowMs: number;
}): void {
  const reachable = new Set(viewState.reachableKeys);
  const path = new Set(viewState.pathKeys);
  const attackableTiles = new Set(viewState.attackableTileKeys);

  drawTileOverlaysLayer({
    ctx,
    state,
    viewState,
    usableReachable: reachable,
    path,
    attackableTiles,
  });
  drawCaptureBarsLayer({
    ctx,
    state,
    hiddenTileKeys: new Set(viewState.hiddenCaptureBarTileKeys),
    hoverPreview: viewState.captureBarHoverPreview,
  });
  drawFxUnderUnitsLayer({ ctx, animation, nowMs });
  drawUnitsLayer({ ctx, state, viewState, animation, nowMs });
  drawFxOverUnitsLayer({ ctx, animation, nowMs });
  drawAttackRangeFlashLayer({
    ctx,
    state,
    viewState,
    nowMs,
  });
}
